"use strict";
/**
 * NOTE: This component will inject the Google Maps API if not already loaded.
 * `<script type="text/javascript" src="https://maps.google.com/maps/api/js?v=VERSION&key=API_KEY&libraries=places"></script>`
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleMapAutocomplete = void 0;
var React = require("react");
var utility_1 = require("../utility");
var GoogleMapAutocomplete = /** @class */ (function (_super) {
    __extends(GoogleMapAutocomplete, _super);
    function GoogleMapAutocomplete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inputElement = React.createRef();
        _this.handleChange = function (event) {
            if (_this.props.onChange) {
                _this.props.onChange(event);
            }
        };
        _this.handleSelect = function () {
            var place = _this.state.googleMapAutocomplete.getPlace();
            if (place.place_id) {
                _this.props.onSelect(place);
            }
        };
        return _this;
    }
    GoogleMapAutocomplete.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var googleMapAutocomplete;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!window.hasOwnProperty("google") || !google.maps.places)) return [3 /*break*/, 2];
                        if (!this.props.googleMapsApiVersion || !this.props.googleMapsApiKey) {
                            throw new Error("Google Maps API has not been pre-loaded and no Version or API Key has been provided.");
                        }
                        return [4 /*yield*/, utility_1.InjectScript("https://maps.google.com/maps/api/js?v=" + this.props.googleMapsApiVersion + "&key=" + this.props.googleMapsApiKey + "&libraries=places")];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        googleMapAutocomplete = new google.maps.places.Autocomplete(this.inputElement.current, __assign({}, this.props.googleMapsAutocompleteOptions));
                        googleMapAutocomplete.addListener("place_changed", function () { return _this.handleSelect(); });
                        this.disableAutofill();
                        this.setState({
                            googleMapAutocomplete: googleMapAutocomplete,
                        }, function () { return _this.props.callback && _this.props.callback(_this); });
                        return [2 /*return*/];
                }
            });
        });
    };
    GoogleMapAutocomplete.prototype.getPlace = function () {
        return this.state.googleMapAutocomplete.getPlace();
    };
    GoogleMapAutocomplete.prototype.disableAutofill = function () {
        var _this = this;
        if (window.MutationObserver) {
            var mutationObserver_1 = new MutationObserver(function () {
                mutationObserver_1.disconnect();
                if (_this.inputElement && _this.inputElement.current) {
                    _this.inputElement.current.autocomplete = "disable-autofill";
                }
            });
            mutationObserver_1.observe(this.inputElement.current, {
                attributes: true,
                attributeFilter: ["autocomplete"],
            });
        }
    };
    GoogleMapAutocomplete.prototype.render = function () {
        return (React.createElement("input", { ref: this.inputElement, style: this.props.style, className: this.props.className, onChange: this.handleChange, placeholder: this.props.placeholder }));
    };
    return GoogleMapAutocomplete;
}(React.Component));
exports.GoogleMapAutocomplete = GoogleMapAutocomplete;
//# sourceMappingURL=google-map-autocomplete.js.map